module.exports = __webpack_public_path__ + "img/talron-expand.61d40df1.svg";